import type { ReactElement } from 'react'
import { CheckIcon, RefreshCcw01Icon } from '@/components/ui/icons'
import { useTranslation } from '@/translations/i18n'

export type BadgeType = 'selection' | 'to_revise' | 'manually_retouched'

const badgeTypeToIconDescription = {
	manually_retouched: {
		icon: <CheckIcon size={12} />,
		label: 'common:manually_retouched'
	},
	selection: {
		icon: <CheckIcon size={12} />,
		label: 'common:selected'
	},
	to_revise: {
		icon: <RefreshCcw01Icon size={12} />,
		label: 'photoset:needs_review.to_revise'
	}
} as const satisfies Record<BadgeType, { icon: ReactElement; label: string }>

export const ImageBadge = ({ type }: { type: BadgeType }) => {
	const { t } = useTranslation()
	return (
		<div className='flex shrink-0 items-center justify-between gap-1 [&_svg]:fill-neutral-white'>
			<span className='flex h-[18px] w-[18px] items-center justify-center rounded-2xl bg-neutral-700'>
				{badgeTypeToIconDescription[type].icon}
			</span>
			<p className='font-medium text-neutral-900 text-xs'>
				{t(badgeTypeToIconDescription[type].label)}
			</p>
		</div>
	)
}
